<template>
    <div :class="[ {'grid--left': template == 'left'}, {'grid--right': template == 'right'} ]" class="grid">
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.grid {
    padding-top: 2rem;
    padding-bottom: 2rem;
    display: grid;
    grid-gap: 1rem;
    align-items: flex-start;
    &--left {
        grid-template-columns: calc(30% - 0.5rem) calc(70% - 0.5rem);
    }
    &--right {
        grid-template-columns: calc(70% - 0.5rem) calc(30% - 0.5rem);
    }
    @media (max-width: 992px) {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        &--left {
            grid-template-columns: 100%;
        }
        &--right {
            grid-template-columns: 100%;
        }
    }
}
</style>

